import clsx from "clsx";
import { IInvoice } from "../../utils/quoteUtils";

/**
 * InvoiceStatusDot is a component that displays a dot to represent the status of an invoice.
 * @param status - The status of the invoice.
 * @param expiration - The expiration date of the invoice.
 * @returns A div element with a class name that represents the status of the invoice.
 */
export const InvoiceStatusDot = ({
  status,
  expiration,
}: {
  status: IInvoice["status"];
  expiration?: number;
}) => {
  let statusType: "active" | "expired" | "pending" | "none";

  switch (status) {
    case "Activated":
      if (expiration && expiration < Math.floor(Date.now() / 1000)) {
        statusType = "expired";
      } else {
        statusType = "active";
      }
      break;
    case "PO Received (Good)":
    case "PO Received (Needs Updating)":
    case "CC/Check Payment Requested":
    case "CC/Check Payment Received":
      statusType = "pending";
      break;
    case "":
      statusType = "none";
      break;
    default:
      statusType = "none";
      break;
  }

  return (
    <div
      className={clsx(
        `inline-block h-4 w-4 rounded-full`,
        statusType === "active"
          ? "bg-green-500"
          : statusType === "expired"
          ? "bg-red-500"
          : statusType === "pending"
          ? "bg-yellow-500"
          : "bg-gray-500"
      )}
    ></div>
  );
};
